import { Dayjs } from 'dayjs'
import { OrderFulfillmentStatus, OrderPaymentStatus, OrderStatus } from 'models'
export interface IFilterData {
    employees: any[]
}
export const SELL_SET_ORDER_LOOKUP_DIALOG_STATUS =
    'SELL_SET_ORDER_LOOKUP_DIALOG_STATUS'
export const ORDER_LOOKUP_DIALOG_SHOW_AND_REDIRECT_TO_ORDER =
    'ORDER_LOOKUP_DIALOG_SHOW_AND_REDIRECT_TO_ORDER'
export const ORDER_LOOKUP_DIALOG_RESET_AUTO_REDIRECT =
    'ORDER_LOOKUP_DIALOG_RESET_AUTO_REDIRECT'
export const SELL_REDIRECT_TO_ORDER = 'SELL_REDIRECT_TO_ORDER'

export interface searchOrderRequest {
    employeeIDs?: string[]
    orderFulfillmentTypeIDs?: number[]
    startDate?: Dayjs
    endDate?: Dayjs
    orderChannelIDs?: number[]
    status?: OrderStatus[]
    fulfillmentStatus?: OrderFulfillmentStatus[]
    paymentStatus?: OrderPaymentStatus[]
    orderIDs?: string[]
    isIncludeOrderLines?: boolean
}

export interface searchOrdersRequest {
    status: OrderStatus[]
}
